import React, { useRef, useEffect } from 'react';

import { ProgressBarColor } from './ProgressBar';

export interface ProgressDataItem {
  label: string,
  value: number,
  new: number,
  color: ProgressBarColor,
  showInStats?: boolean,
}
export interface ProgressData {
  items: Array<ProgressDataItem>,
  total: number,
  approvable: number,
  approvableNew: number,
}

export const getVisualProgressData: (data?: {
  approved: number,
  approvedNew: number,
  unapproved: number,
  unapprovedNew: number,
  rejected: number,
  rejectedNew: number,
  equal: number,
  equalNew: number,
} | null) => ProgressData = (data) => (!data ?
  { items: [], approvable: 0, approvableNew: 0, total: 0 } :
  {
    items: [
      {
        label: 'no changes',
        value: data.equal,
        new: data.equalNew,
        color: ProgressBarColor.GREEN_LIGHT,
      },
      {
        label: 'accepted',
        value: data.approved,
        new: data.approvedNew,
        color: ProgressBarColor.GREEN,
      },
      {
        label: 'rejected',
        value: data.rejected,
        new: data.rejectedNew,
        color: ProgressBarColor.RED,
      },
      {
        label: 'for review',
        value: data.unapproved,
        new: data.unapprovedNew,
        color: ProgressBarColor.ORANGE,
        showInStats: true,
      },
    ],
    total: data.equal + data.rejected + data.unapproved + data.approved,
    approvable: data.equal + data.rejected + data.unapproved,
    approvableNew: data.equalNew + data.rejectedNew + data.unapprovedNew,
  }
);

export const usePrevious = <T>(value: T) => {
  const ref = useRef<T>();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
};
